import React, {useEffect, useState} from "react";
import "./Pay.scss";
import {TabsProps} from "antd";
import PendingTab from "./PendingTab/PendingTab";
import RefundListTab from "./RefundListTab/RefundListTab";
import PayTab from "./PayTab/PayTab";
import FreeListTab from "./FreeListTab/FreeListTab";
import PaidTab from "./PaidTab/PaidTab";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  setActiveKey,
  setButtonsHeader,
  setSiderKey,
} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import {HistoryExamine, Tabs} from "components/common";
import GuaranteeList from "./PushDataXML/PushDataXML";
import ReportPay from "./ReportPay/ReportPay";

const itemsInit: TabsProps["items"] = [
  {
    key: tabKeys.PAY.LIST_PENDING,
    label: "Danh sách chờ",
    children: <PendingTab></PendingTab>,
  },
  {
    key: tabKeys.PAY.PAY_TAB,
    label: "Thanh toán",
    children: <PayTab />,
    // disabled: isPayTabDisabled
  },
  {
    key: tabKeys.PAY.HISTORY,
    label: "Lịch sử khám bệnh",
    children: <HistoryExamine />,
    // disabled: isPayTabDisabled
  },
  // {
  //   key: tabKeys.PAY.PAY_OTHER,
  //   label: "Chi khác",
  //   children: "",
  // },
  // {
  //   key: tabKeys.PAY.COLLECTION_OTHER,
  //   label: "Thu khác",
  //   children: "",
  // },
  {
    key: tabKeys.PAY.REPORT,
    label: "Báo cáo",
    children: <ReportPay />,
    // disabled: isPayTabDisabled
  },
];

const Pay = () => {
  const [isPayTabDisabled, setIsPayTabDisabled] = useState(true);
  document.title = "Thanh toán";
  const dispatch = useAppDispatch();
  const activeKey = useAppSelector(state => state.common.activeTab);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const idTT = useAppSelector(state => state.reduxCommon.id);
  useEffect(() => {
    dispatch(setSiderKey("thanhToan"));
    // dispatch(setActiveKey(tabKeys.PAY.LIST_PENDING))
  }, []);
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, [activeKey]);

  useEffect(() => {
    itemsInit[1].disabled = idTT == null;
    itemsInit[2].disabled = idTT == null;
    setItems([...itemsInit]);
  }, [idTT]);
  return (
    <div className="pay page">
      <div className="main">
        <Tabs activeKey={activeKey} items={items} />
      </div>
    </div>
  );
};

export default Pay;
